export default __webpack_public_path__ + "static/media/pof-cardStatement.461e27e1.png";